import {createRouter, createWebHashHistory} from "vue-router";
import store from "@/store/store";
import axios from "axios";
import util from "@/util/util";
import noUser from "@/components/error/noUser";
import beforeHome from "@/components/beforeHome.vue";
import geneticHome from "@/components/geneticHome.vue";
import geneticAdmin from "@/components/admin/geneticAdmin.vue";
import recordHistory from "@/components/history/recordHistory.vue";

/*配置路由*/
const routes = [
    {path: '', redirect: "/beforeHome"},
    {path: '/', redirect: "/beforeHome"},
    {path: '/noUser', component: noUser, meta: {index: 0}},
    {path: '/beforeHome', component: beforeHome, meta: {index: 1}},
    {path: '/home', component: geneticHome, meta: {index: 1}},
    {path: '/history', component: recordHistory, meta: {index: 1}},
    {path: '/geneticAdmin', component: geneticAdmin, meta: {index: 1}},
]

/*导出路由模块*/
var router = createRouter({
    history: createWebHashHistory(),
    routes: routes
})

router.beforeEach((to, form, next) => {
    const user = store.getters.getUser;
    const visit = store.getters.getVisit;
    if (to.path !== '/noUser' && to.path !== '/error' && to.path !== "/beforeHome") {
        if (user === undefined || visit === undefined) {
            axios.post("/home/getUserInfo", {}).then(function (res) {
                if (res.data.code === util.SUCCESS) {
                    store.commit("saveUser", res.data.retMap.user);
                    store.commit("saveVisit", res.data.retMap.visit);
                    if (res.data.retMap.visit.status !== '01'){
                        next({path: "/beforeHome"});
                    }else {
                        next();
                    }
                } else {
                    util.error(res.data.code);
                    next({path: "/noUser"});
                }
            }).catch(function (res) {
                util.catchErr(res);
                next({path: "/noUser"});
            })
        }else if (visit.status !== "01"){
            next({path: "/beforeHome"});
        }else {
            next();
        }
    } else {
        next();
    }
})

export default router
